import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouteService } from '../../services/route.service';

interface StatCard {
  icon: string;
  value: string;
  label: string;
  color: 'blue' | 'green' | 'purple' | 'orange';
}

@Component({
  selector: 'app-home-page',
  imports: [CommonModule],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {

    statCards: StatCard[] = [
    {
      icon: 'fas fa-shopping-cart',
      value: '-',
      label: 'Total Reservations',
      color: 'green'
    },
    {
      icon: 'fas fa-users',
      value: '-',
      label: 'Total Users',
      color: 'blue'
    },
    /*
    {
      icon: 'fas fa-dollar-sign',
      value: '$24,567',
      label: 'Total Revenue',
      color: 'purple'
    },
    {
      icon: 'fas fa-chart-line',
      value: '89.2%',
      label: 'Growth Rate',
      color: 'orange'
    }
      */
  ];

  constructor(private routeService: RouteService) {
    // Initialization logic can go here if needed
  }

  addNewUser(): void {
    this.routeService.userCreate();
  }

  addNewReservation(): void {
    this.routeService.reservationCreate();
  }

}
